export default __webpack_public_path__ + "static/media/sankalp1.208488fd.jpg";